import { baseUrl } from '../shared/api';

export function financialTrustPass(userId, companyId) {
  return `${baseUrl()}/api/v2/users/${userId}/companies/${companyId}/financial_trustpass`;
}

export function financialTrustPassDocument(userId, companyId) {
  return `${baseUrl()}/api/v2/users/${userId}/companies/${companyId}/financial_trustpass/financial_trustpass_documents`;
}

export function apiV2FinancialTrustpassUrl(userId, companyId) {
  return `${baseUrl()}/api/v2/users/${userId}/companies/${companyId}/financial_trustpass`;
}

export function apiV2FinancialTrustpassDocumentsUrl(userId, companyId) {
  return `${baseUrl()}/api/v2/users/${userId}/companies/${companyId}/financial_trustpass` +
   `/financial_trustpass_documents/`;
}

export function apiV2FinancialTrustpassDocumentUrl(userId, companyId, docId) {
  return `${baseUrl()}/api/v2/users/${userId}/companies/${companyId}/financial_trustpass` +
   `/financial_trustpass_documents/${docId}`;
}




// WEBPACK FOOTER //
// ./src/features/financial-trustpass/apiUrls.js